import { CodedError } from '../../CodedError';
import { errorCodes } from '../../constants/errorCodes';

export class HomRSVPError extends CodedError {
  static get errorName() {
    return errorCodes.homRSVPError.code;
  }

  constructor(message: string = errorCodes.homRSVPError.message) {
    super(message);
    this.code = errorCodes.homRSVPError.code;
    this.message = `${message} ${errorCodes.homRSVPError.code}`;
    this.name = errorCodes.homRSVPError.name;
  }
}
